export const actionType={
    setProduct:"setProduct",
    SELECT_PRODUCT:"SELECT_PRODUCT",
    removeProduct: "removeProduct",
    count:'count',
}